import account from './components/account'
import admin from './components/admin'
import system from './components/system'
import bmc from './components/bmc'
import rnc from './components/rnc'
import stripe from './components/stripe'

const api = {
  account,
  admin,
  system,
  bmc,
  rnc,
  stripe
}

export default api

